import { render } from "./DeleteMyAccount.vue?vue&type=template&id=5b9a0f3a"
import script from "./DeleteMyAccount.vue?vue&type=script&lang=js"
export * from "./DeleteMyAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__